import { defineMessages } from 'react-intl';

export default defineMessages({
  'Reverse.Repairer.Errors.RepairerQuote.InvalidStateForQuotationUpdate': {
    id: 'Reverse.Repairer.Errors.RepairerQuote.InvalidStateForQuotationUpdate',
    defaultMessage: "Quote isn't in draft mode",
  },
  'Reverse.Repairer.Errors.RepairerQuote.InvalidTypeForQuotationSubContractorInformationUpdate':
    {
      id: 'Reverse.Repairer.Errors.RepairerQuote.InvalidTypeForQuotationSubContractorInformationUpdate',
      defaultMessage:
        "You can't change subcontractor informations if it's not a subcontrator quote",
    },
  'Reverse.Repairer.Errors.RepairerQuote.QuotationAmountCannotBeLessOrEqualTo0':
    {
      id: 'Reverse.Repairer.Errors.RepairerQuote.QuotationAmountCannotBeLessOrEqualTo0',
      defaultMessage: "Quotation can't be equal or bellow zero",
    },
  'Reverse.Repairer.Errors.RepairerQuote.UnallowedService': {
    id: 'Reverse.Repairer.Errors.RepairerQuote.UnallowedService',
    defaultMessage: 'Unallowed service',
  },
});
